module.exports = __webpack_public_path__ + "static/media/course-bg.47a2ec26.jpg";